import React, { useState } from 'react';
import { API_URL } from '../config';
import { authFetch } from '../utils';

export default function ChangePasswordModal({ onClose }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (newPassword !== confirmPassword) {
      setError('Las contraseñas nuevas no coinciden');
      return;
    }

    setSaving(true);
    try {
      const res = await authFetch(`${API_URL}auth/me/password`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ currentPassword, newPassword })
      });

      if (!res.ok) {
        const message = await res.text();
        setError(message || 'Error al cambiar la contraseña');
        return;
      }

      setSuccess(true);
    } catch (err) {
      console.error(err);
      setError('Error al cambiar la contraseña');
    } finally {
      setSaving(false);
    }
  };

  const inputStyle = {
    padding: '0.75rem',
    fontSize: '1rem',
    borderRadius: '6px',
    border: '1px solid #ccc',
    width: '100%'
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000
      }}
      onClick={onClose}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          maxWidth: '400px',
          width: '90%',
          padding: '2rem 3.5rem 2rem 2rem',
          backgroundColor: '#fff',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem'
        }}
      >
        <h3 style={{ textAlign: 'center', margin: 0 }}>Cambiar contraseña</h3>

        {success ? (
          <>
            <div style={{
              backgroundColor: '#d4edda',
              color: '#155724',
              padding: '0.75rem',
              borderRadius: '6px',
              border: '1px solid #c3e6cb',
              textAlign: 'center'
            }}>
              ✅ Contraseña actualizada correctamente
            </div>
            <button type="button" onClick={onClose} style={{ padding: '0.75rem', backgroundColor: '#6c757d', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>
              Cerrar
            </button>
          </>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {error && (
              <div style={{
                backgroundColor: '#f8d7da',
                color: '#721c24',
                padding: '0.75rem',
                borderRadius: '6px',
                border: '1px solid #f5c6cb',
                textAlign: 'center'
              }}>
                {error}
              </div>
            )}

            <input
              type="password"
              value={currentPassword}
              onChange={e => setCurrentPassword(e.target.value)}
              placeholder="Contraseña actual"
              required
              style={inputStyle}
            />
            <input
              type="password"
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              placeholder="Nueva contraseña"
              required
              style={inputStyle}
            />
            <input
              type="password"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              placeholder="Repetir nueva contraseña"
              required
              style={inputStyle}
            />

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <button type="submit" disabled={saving} style={{ padding: '0.75rem 1.5rem', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>
                {saving ? 'Guardando...' : 'Cambiar'}
              </button>
              <button type="button" onClick={onClose} style={{ padding: '0.75rem 1.5rem', backgroundColor: '#6c757d', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>
                Cancelar
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
